import { TableCell } from '@mui/material'
import React from 'react'

const RowNoFound = ({ colSpan = 0 }) => {
    return (
        <TableCell colSpan={colSpan} data-index={0} sx={{
            textAlign: 'center',
            fontFamily: 'Inter',
            fontWeight: 500,
            fontStyle: 'normal',
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '2%',
            color: '#000000',
            overflowWrap: 'break-word',
        }}>No Records Found</TableCell>
    )
}

export default RowNoFound